import type { ProcessingStageId } from '@lib/upload-processing/types/processing-stage-id';
import type { UploadProcessingProgressUpdate } from '@lib/upload-processing/types/upload-processing-progress-update';

import type { Flow } from '../types/flow';
import type { FlowDocumentMeta } from '../types/flow-meta';

/** Replays document-ready (Nutrient viewable) from durable flow meta when the
 *  worker's onDocumentReady publish landed before the client subscribed, or
 *  when realtime drops the message. Unlike first-wave replay, this fires even
 *  when fieldsDetected is still zero (Python path before geometry arrives). */
export function replayMissedDocumentReadyFromFlow(
  flowId: string,
  pending: ReadonlySet<string>,
  flow: Flow,
  consumedDocumentReady: Set<string>,
  onProcessingProgress?: (update: UploadProcessingProgressUpdate) => void,
  onStageChange?: (stage: ProcessingStageId) => void
): void {
  const meta = flow.meta as FlowDocumentMeta | null | undefined;
  const collections = meta?.collections;
  if (!collections) {
    return;
  }

  for (const collectionId of pending) {
    if (consumedDocumentReady.has(collectionId)) {
      continue;
    }

    const collectionMeta = collections[collectionId];
    if (
      !collectionMeta?.storageDocumentId ||
      collectionMeta.status !== 'processing'
    ) {
      continue;
    }

    consumedDocumentReady.add(collectionId);
    onStageChange?.('fields');
    onProcessingProgress?.({
      flowId,
      collectionId,
      stage: 'fields',
      documentId: collectionMeta.storageDocumentId,
      progressLabel: 'Detecting fields…',
    });
  }
}
